const AUTH_PATH = {
  SIGN_IN: '/sign-in',
  SIGN_IN_PASSWORD: '/sign-in/password',
  VERIFIED: '/email-verification',
  PASSWORD_FORGOT: '/password-forgot',
  PASSWORD_RESET: '/password-reset',
  BRIDGE: {
    INDEX: '/bridge',
    IDENTITY_VERIFICATION: '/bridge/identity-verification',
  },
};

const CHAT_PATH = {
  MAIN: '/chat',
  EVENTS: '/chat/events',
  CHATTING_DETAIL_FN: (chatId: string) => `/chat/${chatId}`,
  CHATTING_DETAIL: '/chat/:chatId',
  CHARACTER: {
    INDEX: '/chat/characters',
    CREATE: '/chat/characters/create',
    CREATE_COMPOSITE: '/chat/characters/create/composite',
    CREATE_UNIFIED: '/chat/characters/create/unified',
    DETAIL: '/chat/characters/:characterId',
    EDIT: '/chat/characters/:characterId/edit',
  },
  UNIVERSE: {
    INDEX: '/chat/universes',
    CREATE: '/chat/universes/create',
    DETAIL: '/chat/universes/:universeId',
    EDIT: '/chat/universes/:universeId/edit',
  },
  SCENE: {
    INDEX: '/chat/scenes',
    CREATE: '/chat/scenes/create',
    DETAIL: '/chat/scenes/:sceneId',
    EDIT: '/chat/scenes/:sceneId/edit',
  },
  MY: {
    INDEX: '/chat/my',
    ASSETS: '/chat/my/assets',
    ASSETS_STATISTICS: '/chat/my/assets/statistics',
    HISTORIES: '/chat/my/histories',
    BOOKMARKS: '/chat/my/bookmarks',
    PROFILE: '/chat/my/profile',
    PROFILE_EDIT: '/chat/my/profile/edit',
    SETTINGS: '/chat/my/settings',
    NOTIFICATION_SETTINGS: '/chat/my/notification-settings',
    BLOCK: '/chat/my/block',
    /** 내 공모전 참가 건 — 반려 사유 · 재제출 (#2673) */
    CONTEST_SUBMISSION: '/chat/my/contest-submissions/:submissionId',
    CONTEST_SUBMISSION_FN: (submissionId: string) => `/chat/my/contest-submissions/${submissionId}`,
  },
  CHAT_PAYMENT: {
    INDEX: '/chat/payment',
    ITEM: '/chat/payment/item',
    TICKET: '/chat/payment/ticket',
    FREE: '/chat/payment/free',
    /** 무료충전소 외부 광고(MyChips) — iframe 풀스크린 페이지(자체 뒤로가기 보유) */
    FREE_MAF: '/chat/payment/free/maf',
    NAP: '/chat/payment/nap',
    SUCCESS: '/chat/payment/success',
    FAIL: '/chat/payment/fail',
    PAYLETTER: {
      SUCCESS: '/chat/payment/payletter/success',
      FAILURE: '/chat/payment/payletter/failure',
      WEBVIEW: '/chat/payment/payletter/wv',
    },
    HECTO: {
      SUCCESS: '/chat/payment/hecto/success',
      FAILURE: '/chat/payment/hecto/failure',
      CANCEL: '/chat/payment/hecto/cancel',
      WEBVIEW: '/chat/payment/hecto/wv',
    },
  },
  IDENTITY_VERIFICATION: '/chat/identity-verification',
  SETTING: '/chat/setting',
  SEARCH: '/chat/search',
  NOTIFICATIONS: '/chat/notifications',
  USERS: {
    PROFILE: '/chat/users/:userId/profile',
    PROFILE_FN: (userId: string) => `/chat/users/${userId}/profile`,
  },
  SUPPORT: '/chat/support',
  SUPPORT_INQUIRIES: '/chat/support/inquiries',
  SUPPORT_INQUIRY_CREATE: '/chat/support/inquiries/create',
  SUPPORT_INQUIRY_DETAIL: '/chat/support/inquiries/:inquiryId',
  SUPPORT_INQUIRY_EDIT: '/chat/support/inquiries/:inquiryId/edit',
  SUPPORT_INQUIRY_ADDITIONAL: '/chat/support/inquiries/:inquiryId/additional',
  WITHDRAW: '/chat/withdraw',
  COMMUNITY: '/chat/community',
  COMMUNITY_CREATE: '/chat/community/create',
  COMMUNITY_DETAIL: (communityId: string) => `/chat/community/${communityId}`,
};

const BUBBLETAP_PATH = {
  MAIN: '/chat',
  STUDIO: {
    INDEX: '/studio',
    MY_TITLES: '/studio/titles',

    CREATE_TITLE: '/studio/titles/create',
    EDIT_TITLE: '/studio/titles/:titleId/edit',
    EDIT_TITLE_FN: (titleId?: string) => `/studio/titles/${titleId}/edit`,
    EDITOR: '/studio/editor',
    CREATE_CHAPTER: '/studio/editor/edit/:titleId/create',
    CREATE_CHAPTER_FN: (titleId?: string) => `/studio/editor/edit/${titleId}/create`,
    EDIT_CHAPTER: '/studio/editor/edit/:titleId/:chapterId',
    EDIT_CHAPTER_FN: (titleId?: string, chapterId?: string) => `/studio/editor/edit/${titleId}/${chapterId}`,
    STUDIO_ROOT: '/studio',
    PROFILE: '/studio/profile',
  },

  // MY_TITLES: '/studio/titles',
  // CREATE_TITLE: '/studio/titles/create',
  // PROFILE: '/studio/profile',

  // EDIT_TITLE_FN: (titleId?: string) => `/studio/titles/${titleId}/edit`,
  // CREATE_CHAPTER: (titleId?: string) => `/studio/editor/edit/${titleId}/create`,
  // EDIT_CHAPTER: (titleId?: string, chapterId?: string) => `/studio/editor/edit/${titleId}/${chapterId}`,
  // STUDIO_ROOT: '/studio',
  // STUDIO: '/studio',

  // Web Consume
  BUBBLE_PICK: '/bubblepick',
  HOT_TAP: '/hottap',
  DISCOVER: '/discover',
  TITLES: '/titles',
  TITLE_DETAIL: '/titles/:titleId',
  TITLE_DETAIL_FN: (titleId: string) => `/titles/${titleId}`,
  CHAPTER: '/titles/:titleId/chapters/:chapterId',
  CHAPTER_FN: (titleId: string, chapterId: string, languageCode?: string) =>
    `/titles/${titleId}/chapters/${chapterId}?languageCode=${languageCode ?? 'en'}`,

  AI: '/ai',
  AI_INFO: '/ai/info',
  COMMUNITY: '/community',
  COMMUNITY_DETAIL: (communityId: string) => `/community/${communityId}`,
  SETTING: '/setting',
  WITHDRAWAL: '/withdrawal',
  AD_REWARDS: '/ad-rewards',
  POLICY: {
    INDEX: '/policy',
    BUBBLEUP_VERIFICATION: '/policy/bubbleup-verification',
    BUBBLEUP_TERMS: '/policy/bubbleup-terms',
    /** 일본 특정상거래법 표기 (DMM/FANZA 환경 전용) */
    SPECIFIED_COMMERCIAL_TRANSACTIONS: '/policy/specified-commercial-transactions',
  },
  GUIDE: {
    /** Play 결제 실패 안내 — 앱이 `/{언어}/guide/play-billing#payment|#store` 로 연다(안드로이드 #3663) */
    PLAY_BILLING: '/guide/play-billing',
  },
  USER_PROFILE: '/users/:userId/profile',
  USER_PROFILE_FN: (userId: string) => `/users/${userId}/profile`,
  MY_PROFILE: '/my/profile',
  MY_PROFILE_EDIT: '/my/profile/edit',
  IDENTITY_VERIFICATION: '/my/profile/identity-verification',
  BANK_ACCOUNT_VERIFICATION: '/my/profile/bank-account-verification',
  BANK_ACCOUNT_VERIFICATION_EDIT: '/my/profile/bank-account-verification/edit',
  WEB_PAYMENT: {
    INDEX: '/payment', // 버블 충전소
    ITEM: '/payment/item', // 샴푸/포션 충전소
    TICKET: '/payment/ticket', // 이용권 (광고 제거 등)
    FREE: '/payment/free', // free
    SUCCESS: '/payment/success', // success
    FAIL: '/payment/fail', // fail
  },
} as const;

const CONTEST_PATH = {
  EVENTS: '/events',
  BUBBLE_UP_CHALLENGE: '/bubbleup-challenge',
  CREATOR_APPLY: '/creator-apply',
};

export { AUTH_PATH, CHAT_PATH, BUBBLETAP_PATH, CONTEST_PATH };
